import FragmentPage from '../core/FragmentPage';
import { initHorariosPage, destroyHorariosPage } from '../../tabla_horarios';

export default class HorariosPage extends FragmentPage {
  constructor(meta) {
    super('horarios', meta);
  }

  async onEnter() {
    initHorariosPage();
  }

  async onLeave() {
    destroyHorariosPage();
  }
}
